import React, { Component } from "react";
import "../styles/pages/Access.css"


export class Access extends Component {
    render() {
        return (
            <div className="message">
                Демо период завершен. Для открытия доступа, пожалуйста, напишите <a href="mailto: klopovaog@yandex.ru">нам на почту</a>.
            </div>    
        );
    }
}